import alt from 'components/Dispatcher';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import {Map, Record} from 'immutable';

// TODO remove this entirely. It's not hooked up to any actions.
//   Waveforms are no longer populated.
@immutableStore
class FilePlayerWaveformStore {
  constructor() {
    this.state = new Record({
      waveforms: Map(),
    })();
  }
}

export default alt.createStore(FilePlayerWaveformStore, 'FilePlayerWaveformStore');
